import React from "react";
import { useSelector } from "react-redux";
import Mode1 from "./DisplayMode1"
import Mode2 from "./DisplayMode2"
import Mode3 from "./DisplayMode3"
import Mode4 from "./DisplayMode4"
import Mode5 from "./DisplayMode5"
import Mode6 from "./DisplayMode6"
import Mode7 from "./DisplayMode7"

const DisplayMode = (props)=>{
    const { user: currentUser } = useSelector((state) => state.auth);


    let mode;
    // console.log('settings', settings)
    switch (Object.keys(props.HomePage.DisplayModeMasterFrame.DisplayModeSQL[0])[0]) {
      case 'SurveyDisplayMode1Frame':
        mode = <Mode1 {...props.HomePage.DisplayModeMasterFrame.DisplayModeSQL[0]} settings={props.settings}/>
        break
      case 'SurveyDisplayMode2Frame':
        mode = <Mode2 {...props.HomePage} settings={props.settings} />
        break
      case 'SurveyDisplayMode3Frame':
        mode = <Mode3 {...props.HomePage} settings={props.settings} auth={currentUser.AuthToken} />
        break
      case 'SurveyDisplayMode4Frame':
        mode = <Mode4 {...props.HomePage} settings={props.settings} />
        break
      case 'SurveyDisplayMode5Frame':
        mode = <Mode5 {...props.HomePage.DisplayModeMasterFrame.DisplayModeSQL[0]} settings={props.settings}/>
        break
      case 'SurveyDisplayMode6Frame':
        mode = <Mode6 {...props.HomePage.DisplayModeMasterFrame.DisplayModeSQL[0]} settings={props.settings}/>
        break
      case 'SurveyDisplayMode7Frame':
        mode = <Mode7 {...props.HomePage.DisplayModeMasterFrame.DisplayModeSQL[0]} settings={props.settings}/>
        break
      default:
        break;

    }

    return mode
    
}

export default DisplayMode